__turbopack_context__.v({
  "email-signature-loading-dots-wrapper": "EmailSignatureLoadingVeneer-module-scss-module__QLA_wa__email-signature-loading-dots-wrapper",
  "email-signature-loading-text": "EmailSignatureLoadingVeneer-module-scss-module__QLA_wa__email-signature-loading-text",
  "email-signature-loading-veneer": "EmailSignatureLoadingVeneer-module-scss-module__QLA_wa__email-signature-loading-veneer",
  "email-signature-loading-veneer-container": "EmailSignatureLoadingVeneer-module-scss-module__QLA_wa__email-signature-loading-veneer-container",
});
